// cohorts/detail services
// Pure async functions only: no React, no hooks, no state. Parse at this boundary.
import { privateApi } from "@core/libs/axios";
import { parseWith } from "@core/parse";
import { CohortSchema, type Cohort } from "../../_shared/types";

/**
 * `GET /cohorts/{id}/`: one cohort with its counts, `revision` and `available_actions`. A cohort
 * that does not exist and one outside this account's scope both answer `404 cohort_not_found`, so
 * the screen shows the same not-found state for both.
 */
export async function getCohort(id: string): Promise<Cohort> {
  const path = `/cohorts/${id}/`;
  const dto = await privateApi.get<unknown>(path).then((r) => r.data);
  return parseWith(CohortSchema, dto, `GET ${path}`);
}
